let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9NBjE")).then(() => parcelRequire('989RU'));